// 14-day feature tour shown on the TrialCountdownBanner.
// Every day has a feature tip. The sticky bottom bar handles the
// countdown/urgency; this file is pure tour content.
//
// Stable ordering — every trial user sees the same feature on the
// same day. This lets us correlate conversion data by tour-day.
//
// Order rationale (see md/archive/userV3_update/Trial-Experience.md):
//   Day 1-2  — core loop (orientation + chat)
//   Day 3-4  — aha moments (Threads + Fabric)
//   Day 5-7  — expansion (Routines, Integrations, Actions)
//   Day 8-9  — lifestyle (Recipe + Read)
//   Day 10   — sticky (+Plus One)
//   Day 11   — voice (Hum)
//   Day 12   — passive signal (Whispers)
//   Day 13   — ownership (Vault)
//   Day 14   — anywhere (Tiny Fülkit)

export const TRIAL_TOUR = [
  {
    day: 1,
    feature: "Welcome",
    tip: "14 days to make F\u00fclkit yours. Something new each day \u2014 start here.",
    cta: "Begin",
    href: "/home",
  },
  {
    day: 2,
    feature: "Chat",
    tip: "Ask anything. F\u00fclkit remembers what you say between sessions.",
    cta: "Say hi",
    href: "/chat",
  },
  {
    day: 3,
    feature: "Threads",
    tip: "Your work, on a board. Drag cards. Tell F\u00fclkit what to do next.",
    cta: "Open Threads",
    href: "/threads",
  },
  {
    day: 4,
    feature: "Fabric",
    tip: "Your music becomes a live landscape. Save sets. Build a record store.",
    cta: "Open Fabric",
    href: "/fabric",
  },
  {
    day: 5,
    feature: "Routines",
    tip: "Set up your morning once. Check it off every day, no API calls needed.",
    cta: "Build one",
    href: "/routines",
  },
  {
    day: 6,
    feature: "Connect your stack",
    tip: "Plug in Calendar, Gmail, Spotify \u2014 F\u00fclkit talks to all of them.",
    cta: "Connect one",
    href: "/settings/sources",
  },
  {
    day: 7,
    feature: "Actions",
    tip: "Your task layer. Lenses, statuses, and what\u2019s next \u2014 all in one place.",
    cta: "Open Actions",
    href: "/actions",
  },
  {
    day: 8,
    feature: "Dinner ideas",
    tip: "No ads, no life story, no 20 paragraphs. Just the recipe.",
    cta: "See one",
    href: "/recipe",
  },
  {
    day: 9,
    feature: "Read",
    tip: "News, stripped clean. Real sources. No outrage bait.",
    cta: "Open Read",
    href: "/read",
  },
  {
    day: 10,
    feature: "+Plus One",
    tip: "Share a household. Tasks, lists, kid context \u2014 one place, private.",
    cta: "Invite",
    href: "/settings",
  },
  {
    day: 11,
    feature: "Hum",
    tip: "Tap the orb. Speak instead of type. Voice in, voice out.",
    cta: "Open Hum",
    href: "/hum",
  },
  {
    day: 12,
    feature: "Whispers",
    tip: "F\u00fclkit notices. Whispers surface the things you asked to be reminded about \u2014 your own words, back to you.",
    cta: "See whispers",
    href: "/home",
  },
  {
    day: 13,
    feature: "Vault",
    tip: "Your notes live with you. A folder on your machine \u2014 move it, back it up, leave anytime.",
    cta: "Open Vault",
    href: "/settings/vault",
  },
  {
    day: 14,
    feature: "Tiny F\u00fclkit",
    tip: "Cmd+Shift+C opens a floating F\u00fclkit \u2014 a side window while you work anywhere else.",
    cta: "Try it",
    href: "/home",
  },
];

// Compute which tour day a user is on given their trial_ends_at.
// Returns 1..14 during trial, or null if out of range.
export function tourDayForProfile(profile) {
  if (!profile || !profile.trial_ends_at) return null;
  const end = new Date(profile.trial_ends_at).getTime();
  const daysLeft = Math.ceil((end - Date.now()) / 86400000);
  if (daysLeft <= 0 || daysLeft > 14) return null;
  // Day 1 = 14 days left, Day 14 = 1 day left
  return 15 - daysLeft;
}

export function tipForDay(day) {
  return TRIAL_TOUR.find((t) => t.day === day) || null;
}
